<div class="modal" id="addModal" tabindex="-1" role="dialog" aria-labelledby="addInsights" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content iom-modewhite">
            <div class="modal-header border-0">
                <h5 class="modal-title" id="addInsights">{{InsightTitle}}</h5>
                <button type="button" (click)="closedInsights()" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row myw-grid iom-form">
                    <div class="col-12 col-xl-3">
                        <div class="form-group">
                            <select class="form-control mdl-frm-ctl" [(ngModel)]="selectedChartType"
                                (change)="disableLegendAndSwap($event)">
                                <option value="Select">Select Chart Type</option>
                                <option *ngFor="let t of lstChartType" [value]="t">
                                    {{t}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-5 col-xl-3">
                        <div class="form-group">
                            <select class="form-control mdl-frm-ctl offset-xl-0" [(ngModel)]="selectedAxis">
                                <option value="Select">Select Axis</option>
                                <option *ngFor="let t of lstAxis" [value]="t">
                                    {{t}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-2 col-xl-1 text-center pt-2" [class.disabled]="disableLegend">
                        <a (click)="switchAxisLegend();" href="javascript:;"><img src="assets/images/switch.svg"
                                alt="switch" class="myw-icon myw-24" /></a>
                    </div>
                    <div class="col-5 col-xl-3">
                        <div id="ddlLegend" class="form-group">
                            <select *ngIf="selectedChartType != 'Combo'" class="form-control mdl-frm-ctl"
                                [(ngModel)]="selectedLegend" [disabled]="disableLegend">
                                <option value="Select">Select Legend</option>
                                <option *ngFor="let t of lstLegend" [value]="t">
                                    {{t}}</option>
                            </select>
                            <select *ngIf="selectedChartType == 'Combo'" class="form-control mdl-frm-ctl"
                                [(ngModel)]="selectedLegend" [disabled]="disableLegend">
                                <option value="Select"> Select Legend</option>
                                <option *ngFor="let t of lstDataValue" [value]="t">
                                    {{t}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-5 col-xl-3">
                        <div class="form-group">
                            <select class="form-control mdl-frm-ctl" [(ngModel)]="selectedValue">
                                <option value="Select">Select Value</option>
                                <option *ngFor="let t of lstDataValue" [value]="t">
                                    {{t}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- <div class="col-5 col-xl-3 offset-xl-0 offset-md-2 deep-adddwn form-control mdl-frm-ctl">
                        <div class="dropdown-toggle" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <a href="javascript:;" role="button" class="">
                                <span>Insights</span>
                            </a>
                        </div>
                        <div class="dropdown-menu dropdown-md" aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(634px, 86px, 0px);">
                            <div class="dropdown-item" href="#">
                                <a href="javascript:;">
                                  <span>
                                     <label class="myw-checkbox">
                                        <input type="checkbox" (click)="selectAllCategory();" class="selectAllCategory" />
                                        Select All
                                    </label> 
                                   </span>
                                </a>
                            </div>    
                            <div class="dropdown-item" *ngFor="let t of lstInsight">
                                <a href="javascript:;"> 
                                 <span>  
                                   <label class="myw-checkbox">
                                        <input type="checkbox" (click)="checkSelectedCategory();" class="form-check-input checkCategory"
                                            value="{{t.CategoryId}}^{{t.CategoryName}}" />
                                        <span>{{t.CategoryName}}</span>
                                    </label>
                                  </span>
                                </a>    
                            </div>
                        </div>
                    </div>-->
                </div>
                <div *ngIf="loadChart == true" class="collapse show" id="previewPanel">
                    <h6 class="fs-18">Preview Panel</h6>
                    <div class="card iom-card mt-4" *ngFor="let item of graphData | keyvalue">
                        <div class="card-header">
                            <h4 class="card-title">{{ChartHeading}}</h4>
                        </div>
                        <div *ngIf="item.value" class="card-body" id="container{{GetRowRank(item.key)}}">
                            <app-d3-chart [Data]="item.value" [IsOverAll]="IsOverAll" [Rowrank]="GetRowRank(item.key)"
                                [IsEdit]="true"></app-d3-chart>
                        </div>
                        <div class="card-footer">
                            <div class="text-secondary myw-500">Observation:</div>
                            <div class="text-secondary fs-12">{{Observation}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer iom-modewhite border-0">
                <!-- <button type="button" class="btn btn-secondary" data-bs-toggle="collapse" id="btnPreviewPanel" data-bs-target="#previewPanel"
                    aria-expanded="false" aria-controls="previewPanel"
                    (click)="previeworApplyCharts(true,false);">Preview</button> -->
                <button type="button" class="btn btn-secondary iom-preview" id="btnPreviewPanel"
                    (click)="previeworApplyCharts(true,false);">Preview</button>
                <button *ngIf="this.iomService.readonlyDD == false" type="button" class="btn btn-primary ml-3" data-bs-dismiss="modal" [disabled]="enableApplyButton"
                    (click)="previeworApplyCharts(true,true);">Apply</button>
                <button *ngIf="this.iomService.readonlyDD == true" type="button" class="btn btn-primary ml-3 disabled" data-bs-dismiss="modal">Apply</button>
            </div>
        </div>
    </div>
</div>